<template>
    <div>
        <div class="sga-page-8 page-8">
            <el-form>
                <el-row>
                    <el-col>
                        <p>
                            <i v-if="showRemoveForm" class="el-icon-remove" @click="removeTechnologyForm()"
                                    style="color: #dc3c3c; font-size: 20px; margin-right: .5rem;"></i> Please enter a search term
                        </p>
                        <el-form-item :error="technology.selectionError">
                            <el-select placeholder="Enter a search term..." :filterable="true" :remote="true"
                                :remote-method="filter" v-model="technology.selection" @change="handleSelectionChange"
                                :disabled="showCustomTechnology">
                                <el-option :value="option" v-for="(option, index) in  technologyOptions "
                                    :key="`skill-${index}`">{{
                                        option }}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <button type="button" class="ts-btn ts-btn-small ts-btn-grey ts-btn-wicon ts-btn-full mt20 mb20"
                            style="text-align: left !important" @click="addCustomTechnology">
                            Can't find what you're looking for? Add another technology
                        </button>
                    </el-col>
                </el-row>
                <el-row v-if="showCustomTechnology">
                    <el-form-item :error="technology.customError">
                        <el-col :span="23">
                            <input type="text" autocomplete="off" class="el-input__inner" placeholder="Enter Technology"
                                v-model="technology.custom" />
                        </el-col>

                        <el-col :span="1">
                            <div class="remove-icon-container">
                                <i class="el-icon-circle-close" @click="removeCustomTechnology()"
                                    style="color: #dc3c3c; font-size: 20px; text-align: center; cursor: pointer;"></i>
                            </div>
                        </el-col>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-col>
                        <p>
                            Years of Experience
                        </p>
                        <el-form-item :error="technology.yearsOfExperienceError">
                            <el-select placeholder="Years of experience" v-model="technology.yearsOfExperience">
                                <el-option value="less than a year">Less than one year</el-option>
                                <el-option value="1-2 years">1-2 years</el-option>
                                <el-option value="3-5 years">3-5 years</el-option>
                                <el-option value="5-10 years">5-10 years</el-option>
                                <el-option value="10+ years">10+ years</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>
            </el-form>
        </div>
    </div>
</template>
  
<script>

export default {
    props: {
        showRemoveForm: false,
        technology: {
            selection: {
                type: String
            },
            custom: {
                type: String
            },
            yearsOfExperience: {
                type: String
            },
            selectionError: {
                type: String
            },
            customError: {
                type: String
            },
            yearsOfExperienceError: {
                type: String
            }
        },
    },
    created() {
        if (this.technology.custom) {
            this.showCustomTechnology = true;
            this.$emit("custom-technology-added");
        }
    },
    methods: {
        async filter(searchQuery) {
            this.fetchTechnologies(searchQuery);
        },
        fetchTechnologies(searchQuery) {
            this.$store.dispatch("onet/technologies", { searchQuery }).then((res) => {
                this.technologyOptions = res.map((v) => v.name)
            });
        },
        addCustomTechnology() {
            this.showCustomTechnology = true;
            this.$emit("custom-technology-added");
        },
        removeCustomTechnology() {
            this.showCustomTechnology = false;
            this.$emit("custom-technology-removed");
        },
        handleSelectionChange() {
            if (this.technology.selection !== null) {
                this.showCustomTechnology = false;
                this.$emit("selection-made");
            }
        },
        removeTechnologyForm(){
            this.$emit("technology-form-removed");
        }
    },
    watch: {

        technology(val) {
            this.selectedTechnology = val ? val.selection : null;
        }
    },
    data() {
        return {
            technologyOptions: [],
            showCustomTechnology: false,
            selectionErrorMessage: null,
            yearsOfExperienceErrorMessage: null,
            selectedTechnology: null

        }
    }
};
</script>
  
<style lang="scss" scoped>
button {
    text-align: left;
}

.remove-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.5rem;
    margin-left: 1rem;
}
</style>
  